import {
  combineReducers,
  configureStore,
  createListenerMiddleware,
} from '@reduxjs/toolkit';
import { customerArea } from '@greenkub-fronts/domain/customer-area';
import { auth } from '@greenkub-fronts/domain/auth';
import { catalogue } from '@greenkub-fronts/domain/catalogue';
import { snackbar } from '@greenkub-fronts/domain/snackbar';
import { ui } from '@greenkub-fronts/domain/ui';
import { tunnel } from '@greenkub-fronts/domain/tunnel';
import { upsell } from '@greenkub-fronts/domain/upsell';
import { documentSpace } from '@greenkub-fronts/domain/documents-space';
import { signature } from '@greenkub-fronts/domain/signature';

import { archives } from '@greenkub-fronts/domain/archives';

export const listenerMiddleware = createListenerMiddleware();

interface Dependencies {
  apiSlice: any;
}

export class AppStore {
  private dependencies: any = null;
  private store: any = null;

  initReduxStore (dependencies: Dependencies) {
    this.dependencies = dependencies;

    const rootReducer = combineReducers({
      customerArea,
      auth,
      catalogue,
      snackbar,
      tunnel,
      ui,
      upsell,
      documentSpace,
      archives,
      signature,
      [this.dependencies.apiSlice.reducerPath]:
      this.dependencies.apiSlice.reducer,
    });

    this.store = configureStore({
      reducer: rootReducer,
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          thunk: {
            extraArgument: this.dependencies,
          },
        }).
          concat(this.dependencies.apiSlice.middleware).
          prepend(listenerMiddleware.middleware),
      devTools: true,
    });
  }

  public getStore () {
    return this.store;
  }
}

const AppStoreFactory = () => {
  let instance: AppStore;
  return {
    getInstance: function() {
      if (instance == null) {
        instance = new AppStore();
      }
      return instance as AppStore;
    },
  };
};

export const store = AppStoreFactory().getInstance();
